<template>
  <div class="language-switch">
    <button
      v-for="lang,i in supportedLocales"
      :key="lang"
      @click="switchLanguage(lang)"
      class="px-2 py-1 rounded-lg transition-colors "
      :class="{
        // 'mt-[-10px] mx-[-20px]': i === 0,
        // 'mt-2': i === 1,
        'bg-green-500 text-white z-10': currentLocale === lang,
        'bg-gray-700 text-gray-300 hover:bg-gray-600': currentLocale !== lang,
      }"
    >
      {{ langMap[lang] }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

type LocaleType = 'en-US' | 'zh-CN'

const { locale, availableLocales } = useI18n()

const currentLocale = computed(() => locale.value as LocaleType)

const langMap: Record<LocaleType, string> = {
  'en-US': 'EN',
  'zh-CN': '中',
}

const switchLanguage = (lang: LocaleType) => {
  locale.value = lang
  localStorage.setItem('locale', lang)
}

// 确保 availableLocales 只包含支持的语言
const supportedLocales = computed(() =>
  (availableLocales as string[]).filter(
    (lang): lang is LocaleType => lang === 'en-US' || lang === 'zh-CN',
  ),
)
</script>

<style scoped>
.language-switch {
  @apply flex items-center gap-2;
}
</style>
